import { gql, enableExperimentalFragmentVariables } from '@apollo/client'
import { CompanyFragments } from '@/modules/companies/fragments'
import { UserFragments } from '@/modules/users/fragments'

enableExperimentalFragmentVariables()

export const BOOTSTRAP_QUERY = gql`
  query Bootstrap {
    me {
      ...UserInfo
      ...UserTypes
      salaryGroups {
        id
        name
      }

      isSuperuser
      activeDriverCard {
        ...DriverCardInfo
      }
      driverCards {
        ...DriverCardInfo
      }
      allPermissions
      mostRecentCompany {
        id
        fullName
        shortName
        userHasAccess
      }
      companies {
        id
        fullName
        shortName
        logo
        userHasAccess
      }
    }
    currentCompany {
      ...CompanyInfo
      ...CompanyUserTypes
      leaderGroups {
        id
        name
      }
      salaryGroups {
        id
        name
      }
      numberOfUsers
      logo
      useCompanyLogo
      infringementAdminSeverityNotificationThreshold
      userHasAccess
    }
  }
  ${CompanyFragments.info}
  ${CompanyFragments.userTypes}
  ${UserFragments.info}
  ${UserFragments.types}
  ${UserFragments.driverCard}
`

export const GET_JWT_TOKEN_FROM_SHORT_URL = gql`
  query GetJwtTokenFromShortUrl($urlId: String!) {
    getJwtTokenFromShortUrl(urlId: $urlId)
  }
`
